import { useEffect, useRef } from 'react';

// Hook that identifies that component is mounted.
export var useIsMounted = function useIsMounted() {
  var isMounted = useRef(false);
  useEffect(function () {
    /* istanbul ignore else */
    if (!isMounted.current) {
      isMounted.current = true;
    }
  }, []);
  return isMounted.current;
};
export default useIsMounted;